import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// Configuración de la Consola de Firebase (Proyecto kharon-d8d9e)
const firebaseConfig = {
    apiKey: "AIzaSyBDjBSio0-5fjIJ-3tdVpQRdM319oYsGUo",
    authDomain: "kharon-d8d9e.firebaseapp.com",
    projectId: "kharon-d8d9e",
    storageBucket: "kharon-d8d9e.firebasestorage.app",
    messagingSenderId: "517875614182",
    appId: "1:517875614182:web:dc6349509b4733d1aad627"
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Exportar servicios
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, "europe-west1"); // Usamos región europea para menor latencia en España

export default app;
